module.exports = __webpack_public_path__ + "media/sub3-6-1.30559b60.mp4";